import { Control, Controller } from 'react-hook-form';
import { Button, SelectChangeEvent, Stack, Tooltip, Typography } from '@mui/material';
import { BuyInput } from 'features';
import { COLOR_RED, COLOR_SECONDARY, Icons, links } from 'shared';

import { BuyCoinsErrors, FormData } from '../../lib';

type BuyFormProps = {
  control: Control<FormData, any>;
  onChangeStableAmount: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => string | boolean;
  onCurrencyChange: (event: SelectChangeEvent<any>) => void;
  currency: 'USDT' | 'USDC';
  stableAmount: string;
  handleMaxClick: () => Promise<void>;
  isAuthenticated: boolean;
  errors: BuyCoinsErrors;
  receiveAmount: string;
  isValid: boolean;
  isDirty: boolean;
  errorMessage: string | undefined;
};

export const BuyForm = (props: BuyFormProps) => {
  const {
    control,
    onChangeStableAmount,
    onCurrencyChange,
    currency,
    stableAmount,
    handleMaxClick,
    isAuthenticated,
    errors,
    receiveAmount,
    isValid,
    isDirty,
    errorMessage,
  } = props;

  return (
    <Stack mt={1.5} spacing={1}>
      <Controller
        name="stablesAmount"
        control={control}
        render={({ field }) => (
          <BuyInput
            {...field}
            onChange={(e) => {
              const val = onChangeStableAmount(e);

              if (val !== false) {
                field.onChange(val);
              }
            }}
            onCurrencyChange={onCurrencyChange}
            currencyValue={currency}
            stableBalance={stableAmount}
            onMaxClick={handleMaxClick}
            isError={isAuthenticated && !!errors.amount}
          />
        )}
      />
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent={{ xs: 'flex-start', md: 'space-between' }}
        spacing={2}
      >
        <Stack width={{ xs: '100%', md: '45%' }} spacing={1}>
          <Typography className="secondary">You get</Typography>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Icons.Crat />
            <Tooltip
              classes={{
                tooltip: 'secondary',
                arrow: 'secondary',
              }}
              enterTouchDelay={0}
              leaveTouchDelay={3000}
              title={receiveAmount}
              placement="top"
            >
              <Typography fontSize={20} lineHeight="200%" textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
                {receiveAmount}
              </Typography>
            </Tooltip>
          </Stack>
        </Stack>
        <Stack width={{ xs: '100%', md: '55%' }} pt={{ xs: 0, md: 1.5 }} alignItems="center">
          <Button
            type="submit"
            disabled={!isValid || !isDirty || !isAuthenticated}
            sx={{ width: { xs: '100%', md: 130 } }}
          >
            Buy
          </Button>
          {!isValid && !!errorMessage && (
            <Stack pt={1} direction="row" justifyContent="center" alignItems="center" spacing={1}>
              <Icons.InfoCircle sx={{ color: COLOR_RED }} />
              <Typography className="error" variant="body2">
                {errorMessage}
              </Typography>
            </Stack>
          )}
          <Button
            variant="text"
            href={links.howToBuyGitBook}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              pt: 1,
              fontSize: 14,
              fontWeight: 400,
              textDecoration: 'underline',
              color: COLOR_SECONDARY,
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            How To Buy?
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
